import { IconNavigationArrowLeft } from '@s-group/design-system-icons'
import { Link } from '@ui-components/actions/Link'
import { Colors } from '@ui-components/global/colors'
import { SPACE_XXSMALL } from '@ui-components/global/spacing'
import { BodyText } from '@ui-components/typography/Typography'
import { JSX } from 'react'
import { styled } from 'styled-components'

import { FlexColumnContainer } from '../global/CommonStyling'
import { MAIN_STEP_HEADER_HEIGHT } from '../global/constants'

export interface BackActionTopBarProps {
  backLabel: string
  onBackClick: () => void
}

const Container = styled(FlexColumnContainer)`
  width: 100%;
  height: ${MAIN_STEP_HEADER_HEIGHT}px;
  padding: ${SPACE_XXSMALL};
  position: relative;

  a {
    width: fit-content;
  }
`

export const BackActionTopBar = (props: BackActionTopBarProps): JSX.Element => {
  const { backLabel, onBackClick } = props

  return (
    <Container as="nav">
      <Link
        standalone={true}
        color="neutral"
        icon={[IconNavigationArrowLeft, { color: `${Colors.TextDefaultNeutral}` }]}
        onClick={onBackClick}
      >
        <BodyText>{backLabel}</BodyText>
      </Link>
    </Container>
  )
}
